var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.errorPage === 503)?_c('PageErrorApi503'):_vm._e(),(_vm.spinner)?_c('div',{staticClass:"tw-fixed tw-top-1/2 tw-left-1/2 -tw-translate-1/2 tw-z-spinner"},[_c('b-spinner',{attrs:{"variant":"secondary"}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }